import $ from "jquery"
import { API_BASE } from "../../utils/Constants";
import axiosInstance from "../../utils/axios";
import { getToken } from "../../utils/Auth";
import streamSaver, { createWriteStream } from 'streamsaver';
import Swal from "sweetalert2";
streamSaver.mitm = `${window.location.origin}/streamsaver/mitm.html`;

// Helper functions

export const handleDownloadAssessment = async (
    payload,
    setPendingSize,
    setTotalSize,
    downloadModalName,
    zipName = "student-submissions.zip",
    setIsDownloading,
    apiUrl="/downloadStudentSubmissions"
) => {
    try {
        setIsDownloading(true);
        const safeZipName = zipName.replace(/[^a-zA-Z0-9-_]/g, '_') + '.zip';

        // Get total file size
        const sizeRes = await axiosInstance().post(apiUrl, {
            ...payload,
            getSize: true,
        }).catch(() => {
            Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
            $(`#${downloadModalName}`).modal("hide");
            setIsDownloading(false);
            setTotalSize(0);
            setPendingSize(0);
            return;
        });

        const totalFileSize = sizeRes.data.totalFileSize || 0;
        setTotalSize(totalFileSize);

        const throttledProgress = (() => {
            let lastCall = 0;
            return (loaded) => {
                const now = Date.now();
                if (now - lastCall >= 100) {
                    if (loaded < totalFileSize) {
                        setPendingSize(loaded);
                    } else {
                        setPendingSize(totalFileSize);
                    }
                    lastCall = now;
                }
            };
        })();

        const fileStream = createWriteStream(safeZipName, { size: totalFileSize });

        const response = await fetch(`${API_BASE}${apiUrl}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}` },
            body: JSON.stringify(payload),
        }).catch(() => {
            Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
            $(`#${downloadModalName}`).modal("hide");
            setIsDownloading(false);
            setTotalSize(0);
            setPendingSize(0);
            return;
        });

        if (!response.ok) throw new Error('Network response was not ok');
        if (!response.body) throw new Error('No readable stream in response');

        const reader = response.body.getReader();
        const writer = fileStream.getWriter();
        let received = 0;

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            await writer.write(value);
            received += value.length;
            throttledProgress(received);
        }

        setPendingSize(totalFileSize);
        await new Promise(resolve => setTimeout(resolve, 100));
        await writer.close();

    } catch (error) {
        console.error("Download failed:", error);
        Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
    } finally {
        $(`#${downloadModalName}`).modal("hide");
        setIsDownloading(false);
        setTotalSize(0);
        setPendingSize(0);
    }
};